import { Link } from 'react-router-dom';
import Seo from '../components/common/Seo';
import { SITE_NAME, SITE_DESCRIPTION, CONTACT_EMAIL } from '../constants/site';
import { ALL_CATEGORIES, categoryDescription } from '../constants/blogCategories';
import { toSlug } from '../utils/slug';
import { breadcrumbSchema } from '../utils/jsonLd';

// TODO(draft): replace the editorial copy below with the real positioning before
// launch. Everything here is placeholder text with the right structure.
function AboutPage() {
  return (
    <div className="container page prose">
      <Seo
        title="About"
        path="/about"
        description={`What ${SITE_NAME} publishes, who writes it, and how to get in touch.`}
        jsonLd={breadcrumbSchema([
          { name: 'Home', path: '/' },
          { name: 'About', path: '/about' },
        ])}
      />

      <h1 className="page-title">About {SITE_NAME}</h1>
      <p className="page-sub">{SITE_DESCRIPTION}</p>

      <h2>What we publish</h2>
      <p>
        {SITE_NAME} is a general-interest site, not a single-subject one. World events, business,
        technology, sport, entertainment and the practical side of everyday life all belong here —
        if it is worth someone's time to read, it is in scope.
      </p>
      <p>
        Breadth is the point, but the bar is the same for every section: a named author, a check
        before publishing, and a visible date. When a story develops we update the article and
        record the revision date rather than quietly editing it.
      </p>

      <h2>Sections</h2>
      <ul>
        {ALL_CATEGORIES.map((c) => (
          <li key={c}>
            <Link to={`/category/${toSlug(c)}`}>{c}</Link> — {categoryDescription(c)}
          </li>
        ))}
      </ul>

      <h2>Editorial independence</h2>
      <p>
        We do not accept paid placements or sponsored posts dressed up as editorial. Where an
        article links to a product we have a commercial relationship with, that is stated in the
        article itself.
      </p>

      <h2>Corrections</h2>
      <p>
        If something here is wrong, we want to fix it. Email the URL and what is incorrect and we
        will correct the article and note the update.
      </p>

      <h2>Contact</h2>
      <p>
        Questions, corrections or writing pitches:{' '}
        <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
      </p>
    </div>
  );
}

export default AboutPage;
